import { Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { formatPercent } from "../../pages/sourcing-events/buyer/wizard/utils/awardCriteriaStatus";
import { TipTap, isTiptapContentEmpty } from "../input/TipTap/TipTap";
import type { ScorableAwardRow } from "./scorableAwardRows";

interface Props {
  rows: ScorableAwardRow[];
}

export const PriceWeightBreakdown = ({ rows }: Props) => {
  const { t } = useTranslation();
  if (rows.length === 0) return null;

  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" bg="smBackgroundSecondary" px="4" py="3">
      <Text fontSize="sm" fontWeight="medium" mb="2">
        {t("The price weight is split into")}
      </Text>
      <Stack spacing="2">
        {rows.map((row) => (
          <Box key={row.id}>
            <Text fontSize="sm">
              {row.name?.trim() || row.groupLabel}
              {row.effectiveWeightPercent != null && (
                <Text as="span" color="smMuted">
                  {" · "}
                  {t("Weight {{effective}} of the total", { effective: formatPercent(row.effectiveWeightPercent) })}
                </Text>
              )}
            </Text>
            {!isTiptapContentEmpty(row.description) && (
              <Box fontSize="sm" color="smMuted">
                <TipTap content={row.description} editable={false} hasBorder={false} padding="0" maxHeight="" />
              </Box>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
